import Vue from 'vue'
import Vuex from 'vuex'
import { getToken } from '@/utils/auth'

Vue.use(Vuex)


const store = new Vuex.Store({
    state:{


        //当前机构Code
        activeInstitutionCode: null,
        //当前机构的职工Code
        activeStaffCode: null,


        listMenuDTO:null,
        listMenuTop:null,
        listMenuLeft:null,
        //当前顶部导航的项
        activeMenuTop:null,

        loginToken:getToken(),

        tableHeight:200,
        tableWidth:200,

        initDataCamera:null,

    },
    mutations: {

        update(state,[key,value]){
            state[key]=value;
        },

    },

})

export default store
